import styles from './FJHistoryItem.module.less';
import FJDropdownNew from '../../../../common/components/FJDropDown/FJDropdownNew.jsx';
import FJButton from '../../../../common/components/FJButton/FJButton.jsx';
import MoreIcon from '../../../../assets/svg/more.svg?react';
import FJSelectItemsIcon from '../../../../assets/svg/select-items.svg?react';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJDeleteIcon from '../../../../assets/svg/delete-black.svg?react';
import FJDownloadIcon from '../../../../assets/svg/ttv/download-black.svg?react';
import FJCheckBox from '../../../../common/components/FJCheckBox/FJCheckBox.jsx';
import FJEditIcon from '../../../../assets/svg/ttv/edit-1.svg?react';
import PropTypes from 'prop-types';
import { useState, useRef } from 'react';
import classNames from 'classnames';
import FJUtil from '../../../../util/FJUtil.js';

const FJHistoryItem = props => {
    const {
        isMultipleMode,
        isSelected,
        desc,
        createTime,
        onEdit,
        onDownload,
        onSelect,
        onDelete,
        enterMultiple,
        onPreview,
    } = props;

    const [isShowOverlay, setIsShowOverlay] = useState(false);
    const _dropdownRef = useRef(null);

    const _onSelected = (bool, e) => {
        e.stopPropagation();
        if (onSelect) {
            onSelect(bool, e);
        }
    };

    const _onShow = () => {
        setIsShowOverlay(true);
    };

    const _onHide = () => {
        setIsShowOverlay(false);
    };

    const _onOverlayClick = e => {
        FJUtil.forbidEvent(e);
    };

    const _hide = () => {
        setIsShowOverlay(false);
    };

    const _renderTrigger = config => {
        const __onClick = e => {
            e.stopPropagation();
            config.onClick(e);
        };
        return (
            <div onClick={__onClick} ref={config.ref}>
                <FJButton icon={<MoreIcon />} className={styles.icon_btn} type='white' />
            </div>
        );
    };

    const _renderOverlay = config => {
        return (
            <div className={styles.detail_box} ref={config.ref} onClick={_onOverlayClick}>
                <div
                    className={styles.item_btn}
                    onClick={() => {
                        _hide();
                        onEdit();
                    }}
                >
                    <FJEditIcon />
                    {FJLocalStore._('edit')}
                </div>
                <div
                    className={styles.item_btn}
                    onClick={() => {
                        _hide();
                        onDownload();
                    }}
                >
                    <FJDownloadIcon />
                    {FJLocalStore._('download')}
                </div>
                <div
                    className={styles.item_btn}
                    onClick={() => {
                        _hide();
                        enterMultiple();
                    }}
                >
                    <FJSelectItemsIcon />
                    {FJLocalStore._('select')}
                </div>
                <div
                    className={styles.item_btn}
                    onClick={() => {
                        _hide();
                        onDelete();
                    }}
                >
                    <FJDeleteIcon />
                    {FJLocalStore._('delete')}
                </div>
            </div>
        );
    };

    return (
        <div className={styles.box} onClick={onPreview}>
            <div className={styles.time}>{FJUtil.convertToCurrentTimezone(createTime)}</div>
            <div className={classNames(styles.item, isShowOverlay || isMultipleMode ? styles.active : null)}>
                <p>{desc}</p>
                <div className={styles.btn_box}>
                    {!isMultipleMode && (
                        <FJDropdownNew
                            renderTrigger={_renderTrigger}
                            useAnchorBody
                            placement='bottomRight'
                            renderOverlay={_renderOverlay}
                            offsetTop={6}
                            onShow={_onShow}
                            onHide={_onHide}
                            ref={_dropdownRef}
                        />
                    )}
                    {isMultipleMode && <FJCheckBox selected={isSelected} dataChange={_onSelected} />}
                </div>
            </div>
        </div>
    );
};

FJHistoryItem.propTypes = {
    isMultipleMode: PropTypes.bool,
    isSelected: PropTypes.bool,
    desc: PropTypes.string,
    createTime: PropTypes.string,
    onEdit: PropTypes.func,
    onDownload: PropTypes.func,
    onSelect: PropTypes.func,
    onDelete: PropTypes.func,
    onPreview: PropTypes.func,
    enterMultiple: PropTypes.func,
};

export default FJHistoryItem;
